import React from 'react';

import styles from './DisplayGrid.module.scss';

export const DisplayGrid = () => {
  return (
    <div className={styles.displayGrid}>
      <div className={styles.inner} />
    </div>
  );
};
